var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgGuestTagIcon = function SvgGuestTagIcon(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "solid/actions/warning"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96798 5.10245C10.8536 3.54788 13.1464 3.54788 14.032 5.10244L21.7041 18.5689C22.5649 20.0798 21.4445 21.9365 19.6721 21.9365H4.32789C2.55546 21.9365 1.4351 20.0798 2.29587 18.5689L9.96798 5.10245ZM12.9999 17.9365C12.9999 18.4888 12.5522 18.9365 11.9999 18.9365C11.4477 18.9365 10.9999 18.4888 10.9999 17.9365C10.9999 17.3842 11.4477 16.9365 11.9999 16.9365C12.5522 16.9365 12.9999 17.3842 12.9999 17.9365ZM12.7499 9.93652C12.7499 9.52231 12.4142 9.18652 11.9999 9.18652C11.5857 9.18652 11.2499 9.52231 11.2499 9.93652V14.9365C11.2499 15.3507 11.5857 15.6865 11.9999 15.6865C12.4142 15.6865 12.7499 15.3507 12.7499 14.9365V9.93652Z",
    fill: "#FAAD14"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgGuestTagIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "guestTagIcon.c217f34117f76887fa2d063086583366.svg";